<template>
  <div class="helpbody">
    <div class="titlelist" @click="toQuickGuide">
      {{ $t("helpCenter.quickGuide") }}
    </div>
    <div
      class="titlelist"
      v-for="(t, i) in titles"
      :key="'t' + i"
      @click="toDetail(i)"
    >
      {{ t }}
    </div>
    <div class="titlelist" @click="toExAssistance">
      {{ $t("helpCenter.exAssistance") }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      lang: this.$route.params.lang
    };
  },
  computed: {
    titles() {
      return this.$t("helpCenter.title");
    }
  },
  created() {
    this.$i18n.locale = this.lang;
    document.title = this.$t("helpCenter.documentTitle");
  },
  methods: {
    toDetail(i) {
      this.$router.push(`/bs/${this.lang}/help/` + (i + 1));
    },
    toQuickGuide() {
      this.$router.push(`/bs/${this.lang}/help/quickGuide`);
    },
    toExAssistance() {
      this.$router.push(`/bs/${this.lang}/help/exAssistance`);
    }
  }
};
</script>

<style lang="less" scoped>
.helpbody {
  height: 100%;
  box-sizing: border-box;
  background: #111117;
  .titlelist {
    color: #fff;
    line-height: 50px;
    height: 50px;
    position: relative;
    background: #1a1a1f;
    padding-left: 32px;
  }
  .titlelist::before {
    content: "";
    width: 7px;
    height: 7px;
    border-top: 1px solid #999;
    border-right: 1px solid #999;
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    right: 40px;
    transform: rotate(45deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/help_multilingual/home.vue